export default {"src":"/_next/static/media/usdt.3c9cd2f8.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};